export const REPORT_FOR_DAYS = 'REPORT_FOR_DAYS';
export const LIVE_TRACKING_DATA = 'LIVE_TRACKING_DATA';
export const PAST_ORDER_DATA = 'PAST_ORDER_DATA';
export const IDTOKEN = 'ID_TOKEN';
export const ACCESSTOKEN = 'ACCESS_TOKEN';
export const SELECTED_NUMBER = 'SELECTED_NUMBER';
export const SELECTED_PAST_NUMBER = 'SELECTED_PAST_NUMBER';





// WEBPACK FOOTER //
// ./src/service/actionTypes.js